import React from 'react';
import styled from 'styled-components';
import LoginPopup from './LoginPopup';
import SignupPopup from './SignupPopup';

const AuthPopup = ({ step, setStep, onClose }) => {
  return (
    <Wrapper>
      <div className="main-card">
        {step === 'login' 
          ? <LoginPopup setStep={setStep} setShowPopup={onClose} />
          : <SignupPopup setStep={setStep} setShowPopup={onClose}/>}
      </div>
    </Wrapper>
  );
};

export default AuthPopup;

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;

  .main-card {
    background-color: #e9e7e7;
    width: 100%;
    height:80%;
    max-width: 600px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  
`;
